<template>
	<div>
		<topback title="Hang sale information" path="back"></topback>
		<md-field class="mt-6">
            <md-cell-item class="search-item" :title="search_text" @click="showPopUp('top')">
                <iconimg name="search" slot="right"></iconimg>
            </md-cell-item>
            <md-popup
                style="padding: 0.2rem 0 0 0.2rem;"
                v-model="isPopupShow.top"
                position="top"
            >
            <md-popup-title-bar
                ok-text="ok"
                cancel-text="cancel"
                large-radius
                @confirm="hidePopUp('top')"
                @cancel="hidePopUp('top')"
            ></md-popup-title-bar>
            <div class="max-min">
                <md-input-item
                    ref="min_amount"
                    title="Min Itoken"
                    v-model="min_amount"
                    placeholder="Enter the min amount"
                    is-virtual-keyboard
                    virtual-keyboard-vm="minNumberKeyBoard"
                    clearable
                    :error="amount_error"
                >
                </md-input-item>
                <md-number-keyboard type="professional" ref="minNumberKeyBoard" ok-text="Ok"></md-number-keyboard>
                <md-input-item
                    ref="max_amount"
                    title="Max Itoken"
                    v-model="max_amount"
                    placeholder="Enter the max amount"
                    is-virtual-keyboard
                    virtual-keyboard-vm="maxNumberKeyBoard"
                    clearable
                    :error="amount_error"
                >
                </md-input-item>
                <md-number-keyboard type="professional" ref="maxNumberKeyBoard" ok-text="Ok"></md-number-keyboard>
            </div>
            </md-popup>
        </md-field>

        <div class="inrlist">
            <div class="noassets" v-if="showno">
                <md-result-page
                class="customized"
                img-url="/static/icon/noassets.png"
                text="No information for sale"
                subtext="Please use USDT to buy">
                </md-result-page>
                <md-button class="mt-4" type="primary" @click="go_usdt_buy">Go Buy</md-button>
            </div>
            <md-scroll-view v-else ref="listscrollView" :scrolling-x="false" @refreshing="$_onRefresh" :auto-reflow="true" :immediate-check-end-reaching="true"
                @end-reached="$_onEndReached">
                <md-scroll-view-refresh slot="refresh" slot-scope="{ scrollTop, isRefreshActive, isRefreshing }"
                    :scroll-top="scrollTop" :is-refreshing="isRefreshing" :is-refresh-active="isRefreshActive"
                    refresh-text="pull to refresh" refresh-active-text="release refreshable"
                    refreshing-text="refresh"></md-scroll-view-refresh>
                <md-field class="historylist pt-0">
                    <md-cell-item v-for="order in order_list" v-bind:key="order.id">
                        <div slot="left" class="intrust-item">
                            <div class="batchd">
                                <pointtext type="batch" :text="order.orderno"></pointtext>
                            </div>
                            <div class="price">
                                <span class="price-text">Price</span>
                                ₹
                                <md-amount class="amount"
                                    :value="Number(order.amount)"
                                    has-separator
                                ></md-amount>
                            </div>
                            <div class="price">
                                <span class="price-text">Quantity</span>
                                <md-amount class="amount"
                                    :value="Number(order.amount)"
                                    has-separator
                                ></md-amount> IToken
                            </div>
                            <div class="completion">
                                <pointtext type="gift" :text="get_gift(order.amount, true)"></pointtext>
                                <pointtext type="i" :text="get_will_receive(order.amount)"></pointtext>
                            </div>
                        </div>
                        <div slot="right">
                            <md-button size="small" inline @click="showSelector(order.id)">Buy</md-button>
                        </div>
                    </md-cell-item>
                </md-field>
                <md-scroll-view-more slot="more" :is-finished="isFinished" loading-text="Loading" finished-text="no more data">
                </md-scroll-view-more>
            </md-scroll-view>
        </div>
        
        <md-selector class="active_ct" v-model="isSelectorShow" :data="available_ct" hide-title-bar large-radius is-check iconSize="lg"
            @choose="onSelectorChoose">
            <div class="selector-header" slot="header">
                Choose the specified tool to pay
            </div>
            <template slot-scope="{ option, index, selected }">
                <div class="selector-item-body" :class="{ disabled: option.disabled, selected }">
                    <div class="selector-item-left">
                        <iconimg :name="option.value"></iconimg>
                    </div>
                    <div class="selector-item-content">
                        <p class="selector-item-title" v-text="option.text"></p>
                        <p class="selector-item-brief" v-text="`${option.describe}`"></p>
                    </div>
                </div>
            </template>
            <div class="selector-footer" slot="footer">
                <span @click="go_manage_kyc">Manage kyc partner</span>
            </div>
        </md-selector>


	</div>
</template>

<script>
import topback from '@/components/topback'
import pointtext from '@/components/pointtext'
import { Dialog } from 'mand-mobile'
import buyitokeninr from '@/views/recharge/buyitokeninr'
import iconimg from '@/components/iconimg'
import { getpayorder, availablect, downorder } from '@/request/api'

export default {
	name: 'deposithistory',
	components: {
		[topback.name]: topback,
		[pointtext.name]: pointtext,
		buyitokeninr,
        iconimg
	},

	data() {
		return {
            search_text: "Click to search", //Min: 1000 -- Max: 2000
			min_amount: 0,
            max_amount: 9999999,
            amount_error: "",
            isPopupShow: {},
            showno: false,
            isFinished: false,
            page: 1,
            limit: 10,
            order_list: [],
            isSelectorShow: false,
            available_ct: [],
            selectorValue: "",
            orderid: ""
		}
	},
	created() {
        this.$store.dispatch("asyncupdateuserinfo");
        this.$store.dispatch("asyncupdatesiteconfig");
        this.min_amount = this.$route.params.amount;
	},
    mounted() {
    },
	methods: {
        $_onRefresh() {
            console.log("下拉刷新");
            this.search();
        },
        $_onEndReached() {
            if (this.isFinished) {
                return
            }
            console.log("加载更多");
            // async data
            this.get_list(false)
        },
        get_list(refresh) {
            this.$toast.loading('Loading...')
            getpayorder({
                page: this.page,
                limit: this.limit,
                min_amount: this.min_amount,
                max_amount: this.max_amount
            }).then(res=>{
                this.$toast.hide();
                if(res.code === 200) {
                    if (res.data.count === 0) {
                        this.showno = true;
                    } else {
                        this.order_list = this.order_list.concat(res.data.result);
                    }
                    if (this.order_list.length < res.data.count) {
                        this.page = this.page + 1;
                        this.isFinished = false;
                    } else {
                        this.isFinished = true;
                    }
                }
                if(refresh) {
                    this.$refs.listscrollView.finishRefresh();
                }
                this.$refs.listscrollView.finishLoadMore();
            })
        },
        search() {
            this.page = 1;
            this.order_list = [];
            this.get_list(true);
        },
        go_usdt_buy() {
            this.$router.push('/transaction');
        },
        showPopUp(type) {
            this.$set(this.isPopupShow, type, true)
        },
        hidePopUp(type) {
            if(Number(this.min_amount) > Number(this.max_amount)) {
                this.$toast.failed("wrong number range");
                return false;
            } else {
                this.search_text = "Min: " + this.min_amount + " -- Max: " + this.max_amount;
                this.$set(this.isPopupShow, type, false);
                this.search();
            }
            
        },
        showSelector(orderid) {
            this.orderid = orderid;
            availablect().then(res=>{
                if(res.code === 200) {
                    this.isSelectorShow = true;
                    if(Object.keys(res.data).length === 0) {
                        this.available_ct = [{
                            value: 'kyc',
                            text: 'No kyc partner available',
                            describe: "go Manage kyc partner link",
                            disabled: false,
                            id: 0,
                            orderid: 0
                        }];
                    } else {
                        let a_ct = [];
                        for (let i = 0; i < res.data.length; i++) {
                            let obj = res.data[i];
                            let a = {};
                            a.value = obj.text;
                            a.text = obj.text;
                            a.describe = obj.account;
                            a.id = obj.id;
                            a.disabled = false;
                            a.orderid = this.orderid;
                            a_ct.push(a);
                        }
                        this.available_ct = a_ct;
                    }
                } else {
                    this.$toast.failed(res.errmsg);
                }
            })
        },
        onSelectorChoose({text, id, orderid}) {
            if(id === 0) {
                this.go_manage_kyc();
            } else {
                downorder({
                    id: orderid,
                    cctid: id
                }).then(res=>{
                    if(res.code === 200) {
                        Dialog.alert({
                            title: 'Tips',
                            content: 'The pre-order is successful. Please use the designated payment tool to complete the payment within the specified time. If the payment is not made within the specified time, the order will be refunded.',
                            confirmText: 'Ok',
                            onConfirm: () => {
                                this.$router.push('/buyinrdetail/' + orderid+ "/" + id);
                            },
                        })
                    } else {
                        Dialog.alert({
                            title: 'Tips',
                            content: res.errmsg,
                            cancelText: 'Stay',
                            confirmText: 'View order',
                            onConfirm: () => {
                                this.$router.push('/deposithistory/inr');
                            },
                        })
                    }
                })
            }
        },
        get_gift(newVal, return_str) {
            newVal = Number(newVal);
            let mode_set = JSON.parse(this.$store.state.siteconfig.pay_reward_amount);
            
            let principal_reward = newVal * Number(this.$store.state.userinfo.bonus_ratio) * Number("0.01");
            let gift = Number("0");
            if(mode_set.mode === 'ratio') {
                gift = newVal * Number(mode_set.reward) * Number("0.01");
            } else {
                gift = Number(mode_set.reward);
            }
            let reward = (principal_reward + gift).toFixed(2);
            if(return_str) {
                return "TT gift: " + reward; 
            } else {
                return Number(reward);
            }
        },
        get_will_receive(newVal) {
            let principal = Number(newVal);
            let reward = this.get_gift(principal, false)
            let get_itoken = principal + reward;
            return "You will receive: " + get_itoken;
        },
        go_manage_kyc() {
            this.$router.push('/kycpartner')
        }
	}
}
</script>
<style scoped>
.inrlist {
    height: 14rem;
}
/* .search-item >>> .md-cell-item-title {
    color: #d9e0e7;
} */
.max-min {
    background-color: #fff;
    padding: 0.2rem 0 0 0.2rem;
}
.noassets {
margin-top: 1.5rem;
}
.noassets >>> .md-result-image {
width: 1.6rem;
}
.noassets >>> .md-result-text {
    margin: 0;
    color: #01080f;
    font-size: 0.12rem;
}

.noassets >>> .md-result-subtext {
    margin-top: 0.16rem;
    color: red;
    font-size: 0.28rem;
}


.md-card-button {
    color: #198cff;
    display: inline-block;
    padding: 0.07rem 0.07rem;
    background: #198cff;
    position: relative;
    background: 0 0;
    border-radius: 0.16rem;
    border: 3px solid #198cff;
}
.main {
    margin-top: 1rem;
}
.goodscard-group {
    background: #f3f3f6;
    margin: 10px 0;
    border-radius: 20px;
    overflow: hidden;
    padding: 20px;
}
.cell-group {
    background: #232b63;
    margin: 10px 16px;
    border-radius: 20px;
    overflow: hidden;
    padding: 20px;
}
.cell-group>>>.md-cell-item-title {
    color: #f9fafb !important;
}
.cell-group>>>.md-cell-item-body.multilines:before {
    content: none !important;
}
.header-slot{
    padding: 40px 0 20px 0;
}
.header-slot .title{
    color: #111A34;
        font-size: 60px;
        font-family: Songti SC;
        line-height: 1;
}
.header-slot .desc{
    margin-top: 16px;
        color: #858B9C;
        font-size: 26px;
}
.md-field {
    padding: 0rem 0.4rem 0 0.4rem;
}
.intrust-item {
    font-size: 0.26rem;
}
.intrust-item >>> .batch {
    color: black;
}

.intrust-item .batchd {
    margin-left: -9px;
}

.intrust-item .completion {
    margin-left: -0.19rem;
}

.intrust-item .price {
    color: black;
    font-size: 0.3rem;
}
.intrust-item .price .price-text {
    color: #2c3e50;
    font-size: 0.2rem;
}
.intrust-item .price .amount {
    font-weight: 200;
    font-size: 0.3rem;
}
.intrust-item div {
    margin: 4px;
}


.active_ct .selector-header, .selector-footer {
  padding: 15px 40px;
  font-size: 0.37rem;
  color: #ccc;
}

.active_ct .selector-item-body {
  display: flex;
  align-items: center;
}

.active_ct .selector-item-body.selected .selector-item-content {
  color: #2f86f6;
}

.active_ct .selector-item-body.disabled {
  opacity: .3;
}

.active_ct .selector-item-body .selector-item-left {
  flex-shrink: 0;
  margin-right: 32px;
}

.active_ct .selector-item-body .selector-item-left .holder {
  display: block;
  width: 88px;
  height: 88px;
  border-radius: 44px;
  background-color: #e6e6e6;
  font-size: 32px;
  font-weight: 500;
  color: #2f86f6;
  text-align: center;
  line-height: 88px;
}

.active_ct .selector-item-body .selector-item-content {
  flex: 1;
  color: #111a34;
  font-size: 32px;
  line-height: 1.2;
}

.active_ct .selector-item-body .selector-item-content .selector-item-title {
  line-height: 1.2;
}

.active_ct .selector-item-body .selector-item-content .selector-item-brief {
  color: #858b9c;
  font-size: 24px;
  line-height: 1.4;
  margin-top: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/recharge/buyitokeninr.vue